import { IPromoMatchSummary } from "@/core/repositories/promotion";
import { DeductionV2, DeductionV2Props } from "../deduction/deductionV2/DeductionV2";
import { PromotionApplication, PromotionApplicationProps } from "./PromotionApplication";

export interface PromotionDeductionProps {
  deduction: DeductionV2Props;
  matchSummary: IPromoMatchSummary;
  application: PromotionApplicationProps;
}

export class PromotionDeduction {
  private readonly _deduction: DeductionV2;
  private readonly _matchSummary: IPromoMatchSummary;
  private readonly _application: PromotionApplication;

  constructor(props: PromotionDeductionProps) {
    this._deduction = DeductionV2.from(props.deduction);
    this._matchSummary = props.matchSummary;
    this._application = PromotionApplication.from(props.application);
  }

  get deduction(): DeductionV2 {
    return this._deduction;
  }

  get matchSummary(): IPromoMatchSummary {
    return this._matchSummary;
  }

  get application(): PromotionApplication {
    return this._application;
  }

  static from(props: PromotionDeductionProps): PromotionDeduction {
    return new PromotionDeduction(props);
  }
}

const blankMatchSummary = (): IPromoMatchSummary => ({
  isBestMatch: false,
  matchStatus: "",
  confidenceScore: 0,
  rawScore: 0,
  maxApplicableScore: 0,
  displayMatchStatus: "",
  appliedAt: "",
  applicationSource: "",
});

export const getBlankPromotionDeductions = (count: number): PromotionDeduction[] =>
  Array.from({ length: count }, () =>
    new PromotionDeduction({
      deduction: {
        id: 0,
        checkNumber: null,
        invoiceNumber: null,
        invoiceDate: null,
        amount: 0,
        stage: { stageId: 0, stageKey: "", stageName: "", isCurrent: false },
        status: { statusId: 0, statusKey: "", statusName: "", isCurrent: false },
        analystUser: { userId: null, fullName: "", avatar: null, isDeleted: false },
      },
      matchSummary: blankMatchSummary(),
      application: { appliedId: 0, appliedAt: "", applicationSource: "" },
    })
  );
